const sum = (data: number[]): number => {
  return data.reduce((acc, c) => acc + c, 0);
};

export default sum;
